import pathToRegexp from 'path-to-regexp'
import { Route } from 'react-router-dom'
import GifMaker from './gif-maker'
import Upload from './upload'
import ZoomMaker from './zoom'

export const GIF_MAKER = '/create/gifmaker/legacy'
export const ZOOM_MAKER = '/backdrop'

export const START_IMAGE = `/start-image`
export const SLIDESHOW = `/slideshow`
export const VIDEO_TRIM = `/video-trim`
export const DECORATE = `/decorate`
export const DECORATE_NAV = `${DECORATE}/:component`
export const CAPTION = `${DECORATE}/caption`
export const DRAW = `${DECORATE}/draw`
export const STICKERS = `${DECORATE}/stickers`
export const FILTERS = `${DECORATE}/filters`
export const CREATE = `/finalize`
export const DOWNLOAD = `/download`
export const FINALIZE = `/:component(decorate|finalize)/:tool?`

export const UPLOAD = '/upload'
export const UPLOAD_FINALIZE = `${UPLOAD}/finalize`

const gifMakerRouteRegEx = pathToRegexp(GIF_MAKER)

export const matchesRoute = (pathname) => gifMakerRouteRegEx.exec(pathname)

// Can be incorporated into other routes
export default (props) => (
    <div>
        <Route path={GIF_MAKER} render={({ match }) => <GifMaker {...props} match={match} />} />
        <Route path={ZOOM_MAKER} render={({ match }) => <ZoomMaker {...props} match={match} />} />
        <Route path={UPLOAD} render={({ match }) => <Upload {...props} match={match} />} />
    </div>
)
